import { ApiUtility } from "../../../Utilities/ApiUtility.axios";

export enum Vendors_Status {
  All,
  Active,
  Inactive,
  Pending,
  Rejected,
  Deleted,
  Blocked,
}

export enum BankAccountType_New {
  All,
  SavingAccount,
  CurrentAccount,
  CashCreditAccount,
  OverdraftAccount,
  CreditCard,
}

class VendorRegistrationService {
  route = `V1/API/Billing/Acc_Vendor`;

  getAllDetails = (
    clientId: string | undefined,
    start: number,
    length?: number,
    search?: string,
    status?: Vendors_Status
  ) =>
    ApiUtility.get(
      `${this.route}/GetVendorsDetails?companyId=${clientId}?start=${start}&length=${length}&search=${search}&status=${status}`
    );

  postVendorRegData = (vendorId: string | undefined, modal: any) =>
    ApiUtility.post(`${this.route}/${vendorId}`, modal);

  sendVendorRegRequest = (clientId: string | undefined, emailId: any) =>
    ApiUtility.post(
      `${this.route}/SendMail?clientId=${clientId}&emailId=${emailId}`,
      ""
    );
}

export default new VendorRegistrationService();
